/*
 * Copyright 2025 Intuition Robotics ltd
 */
import type {AuditBy, DB_Object} from "@intuitionrobotics/ts-common";
import type {ApiWithBody} from "@intuitionrobotics/thunderstorm";
import type {ApiWithQuery} from "@intuitionrobotics/thunderstorm/shared/types";
import type {DB_User} from "@app/ir-q-app-common/types/care-center/user";
import { PatientGender} from "@app/ir-q-app-common/types/care-center/user";

export type GenderLabel = {
    key: PatientGender
    label: string
}

export const genders: GenderLabel[] = [
    {
        key: PatientGender.FEMALE,
        label: "Female"
    },
    {
        key: PatientGender.MALE,
        label: "Male"
    }
];

export type Api_UpdateAllPatients = ApiWithBody<"/v1/patient/update-all", { patients: DB_Patient[] }, DB_Patient[]>
export type Api_DeletePatients = ApiWithBody<"/v1/patient/delete-patients", {
    deletePatients?: boolean,
    unitIds: string[]
}, DB_Patient[]>
export type Api_AssignPatientsToCaseManager = ApiWithBody<"/v1/case-manager/assign-patients", {
    patientIds: string[],
    caseManager: DB_User
}, DB_Patient[]>
export type Api_GetPatientsForCaseManager = ApiWithQuery<"/v1/case-manager/get-patients", DB_Patient[]>

export type DB_Patient = DB_Object & {
    name: string
    gender?: PatientGender
    unitId: string
    organizationId: string
    timezone: string
    _updated: AuditBy
    _created: AuditBy
    // TODO deprecated for now
    careManagerId?: string
    physicianId?: string
    // TODO: remove this field
    onboarded?: boolean
    privacyAccepted?: boolean
    contactId: string
    _carePlanReviewed?: AuditBy
    birthday?: number,
    caseManagerId?: string
    disabled?: boolean
}

export const DefaultTimezone = "Asia/Jerusalem";
